import React from "react"
import {
  subTitle,
  boxAdvantages,
  titleAdvantages,
} from "./styles/advantages.module.css"
import { Col, Container, Row } from "react-bootstrap"
import yamlData from "../../content/societe/advantages.yaml"

const advantages = () => (
  <Container className={boxAdvantages}>
    <h2 className={titleAdvantages}>{yamlData.title}</h2>
    <Row>
      {yamlData.content.map((data, index) => {
        return (
          <Col lg={4} key={`content_item_${index}`}>
            <div>
              <h3 className={subTitle}>{data.item.subTitle}</h3>
              <p>{data.item.paragraphe}</p>
            </div>
          </Col>
        )
      })}
    </Row>
  </Container>
)

export default advantages
